import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Groups from './pages/Groups';
import Search from './pages/Search';
import GuidesManagement from './pages/GuidesManagement';
import Stats from './pages/Stats';
import Settings from './pages/Settings';
import Map from './pages/Map';
import Complaints from './pages/Complaints';
import GuideAttendance from './pages/GuideAttendance';

function ProtectedRoute({ children, allowedRoles = ['admin', 'guide', 'pool_supervisor'] }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/login" />;
  if (!allowedRoles.includes(user.role)) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={
        <ProtectedRoute allowedRoles={['admin', 'guide', 'pool_supervisor']}><Layout><Dashboard /></Layout></ProtectedRoute>
      } />
      <Route path="/groups" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><Groups /></Layout></ProtectedRoute>
      } />
      <Route path="/search" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><Search /></Layout></ProtectedRoute>
      } />
      <Route path="/guides" element={
        <ProtectedRoute allowedRoles={['admin']}><Layout><GuidesManagement /></Layout></ProtectedRoute>
      } />
      <Route path="/stats" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><Stats /></Layout></ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><Settings /></Layout></ProtectedRoute>
      } />
      <Route path="/map" element={
        <ProtectedRoute allowedRoles={['admin']}><Layout><Map /></Layout></ProtectedRoute>
      } />
      <Route path="/complaints" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><Complaints /></Layout></ProtectedRoute>
      } />
      <Route path="/attendance" element={
        <ProtectedRoute allowedRoles={['admin', 'guide']}><Layout><GuideAttendance /></Layout></ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
